import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=bbbc4964&scoped=true&"
import script from "./user-agreement.vue?vue&type=script&lang=js&"
export * from "./user-agreement.vue?vue&type=script&lang=js&"
import style0 from "./user-agreement.vue?vue&type=style&index=0&id=bbbc4964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbc4964",
  null
  
)

export default component.exports